import React from "react";
import Box from "@mui/material/Box";
import PageTitle from "shared/ui/PageTitle";
import BoxContent from "shared/ui/BoxContent";
import Typography from "@mui/material/Typography";

export const TUTORIAL_VIDEOS = [
    {
        title: "Generare test școlar",
        id: "XLwWZ7nI3t4?si=WHHs2AijJjBhPPbQ",
    },
    {
        title: "Generare test antrenament",
        id: "J0aRn6-aavU?si=8mdMwNGlBdbzUIqq",
    },
    {
        title: "Analiză teste finalizate",
        id: "wzRZJ1eCiwA?si=wkoJdrnM1lZhfRAb",
    },
    {
        title: "Administrare teste proprii",
        id: "cYuEjNoQGJo?si=2eTea0r6gWeBkUpo",
    }
];

export const IFRAME_STYLE: React.CSSProperties = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    width: "100%",
    height: "100%",
    border: "none",
};

export const iFrame = ({videoId} : {videoId: string}) => {
    return <iframe
        style={IFRAME_STYLE}
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube video player"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        referrerPolicy="strict-origin-when-cross-origin"
        allowFullScreen
    />
}

const Tutorials = () => {

    return (
        <Box component="main">
            <PageTitle>Tutoriale</PageTitle>

                {TUTORIAL_VIDEOS.map(({title, id}) => (
                    <Box key={id}>
                        <Typography variant="h3" mb={2} mt={4}>{title}</Typography>
                        <BoxContent>
                            <Box sx={{position: "relative", width: "100%", overflow: "hidden", paddingTop: "56.25%"}}>
                                {iFrame({videoId: id})}
                            </Box>
                        </BoxContent>
                    </Box>
                ))}
        </Box>
    )
}

export default Tutorials;